@use '@design/design-tokens/typography/typography' as *;

@layer chart {
  .assetCardRoot {
    display: flex;
    gap: 8px;
  }

  .details {
    display: flex;
    flex-direction: column;
    text-align: left;

    mark {
      color: var(--text-primary);
      background-color: transparent;
    }
  }

  .titleWrapper {
    display: flex;
    gap: 4px;
    white-space: nowrap;
  }

  .title {
    @include typography-v2-body-sm;
    color: var(--text-default);
    text-transform: uppercase;
  }

  .snake {
    @include typography-v2-body-sm;
    color: var(--text-default);
  }

  .subtitle {
    @include typography-v2-body-xs;
    color: var(--text-soft);
  }
}
